import React from "react";

import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";

import SectionsBreadCrumbs from "components/shared/breadCrumbs/SectionsBreadCrumbs";
import DomainWizard from "components/wizard/DomainWizard";

const AddDomainsPage = () => {
 return (
  <Container maxWidth={false} sx={{ mx: 2, width: "auto" }}>
   <Stack mt={2}>
    <SectionsBreadCrumbs
     links={[
      { name: "home", url: "/" },
      { name: "domains", url: "/domains" },
      { name: "add", url: "/domains/add" }
     ]}
    />
   </Stack>
   <DomainWizard />
  </Container>
 );
};

export default AddDomainsPage;
